package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.uscreen.domain.models.BmiCardBlock
import one.healthium.uscreen.domain.models.ButtonBlock
import one.healthium.uscreen.domain.models.ChoiceListBlock
import one.healthium.uscreen.domain.models.DividerBlock
import one.healthium.uscreen.domain.models.FeatureListBlock
import one.healthium.uscreen.domain.models.HorizontalRulerBlock
import one.healthium.uscreen.domain.models.ImageBlock
import one.healthium.uscreen.domain.models.LabelBlock
import one.healthium.uscreen.domain.models.NotificationPreviewBlock
import one.healthium.uscreen.domain.models.NumberPickerBlock
import one.healthium.uscreen.domain.models.ProgressSliderBlock
import one.healthium.uscreen.domain.models.ReviewCarouselBlock
import one.healthium.uscreen.domain.models.RowBlock
import one.healthium.uscreen.domain.models.SpacerBlock
import one.healthium.uscreen.domain.models.StackBlock
import one.healthium.uscreen.domain.models.TextInputBlock
import one.healthium.uscreen.domain.models.UScreenBlock
import one.healthium.uscreen.domain.models.VerticalRulerBlock
import one.healthium.uscreen.domain.models.WeightGraphBlock
import one.healthium.uscreen.ui.UScreenAnswer
import one.healthium.uscreen.ui.UScreenCallbacks
import one.healthium.uscreen.ui.util.isVisible

@Composable
fun ColumnScope.UScreenBlockRenderer(
    modifier: Modifier = Modifier,
    block: UScreenBlock,
    answers: Map<String, UScreenAnswer>,
    isMale: Boolean?,
    placeholders: Map<String, String>,
    callbacks: UScreenCallbacks,
    scrollable: Boolean = false,
) {
    if (!block.isVisible(answers)) return

    when (block) {
        is BmiCardBlock -> UScreenBmiCardBlock(modifier, block, answers)
        is DividerBlock -> UScreenDividerBlock(modifier, block)
        is SpacerBlock -> UScreenSpacerBlock(modifier, block)
        is LabelBlock -> UScreenLabelBlock(modifier, block, placeholders)
        is ImageBlock -> UScreenImageBlock(modifier, block, isMale)
        is ChoiceListBlock -> UScreenChoiceListBlock(modifier, block, answers, isMale, callbacks::onChoiceSelected, callbacks::onAutoAdvance)
        is TextInputBlock -> UScreenTextInputBlock(modifier, block, answers, callbacks::onTextChanged, callbacks::onKeyboardSubmit)
        is NumberPickerBlock -> UScreenNumberPickerBlock(modifier, block, callbacks::onNumberChanged)
        is VerticalRulerBlock -> {
            val rulerModifier = if (!scrollable) modifier.weight(1f) else modifier
            UScreenVerticalRulerBlock(rulerModifier, block, answers, callbacks::onNumberChanged)
        }
        is HorizontalRulerBlock -> UScreenHorizontalRulerBlock(modifier, block, answers, callbacks::onNumberChanged)
        is NotificationPreviewBlock -> UScreenNotificationPreviewBlock(modifier, block, placeholders)
        is FeatureListBlock -> UScreenFeatureListBlock(modifier, block, isMale, placeholders)
        is ProgressSliderBlock -> UScreenProgressSliderBlock(modifier, block, callbacks)
        is ReviewCarouselBlock -> UScreenReviewCarouselBlock(modifier, block)
        is RowBlock -> UScreenRowBlock(modifier, block, isMale, answers)
        is StackBlock -> UScreenStackBlock(modifier, block, answers, isMale, placeholders, callbacks)
        is ButtonBlock -> UScreenButtonBlock(modifier, block) { callbacks.onButtonAction(block.action) }
        is WeightGraphBlock -> UScreenWeightGraphBlock(modifier, block, answers)
    }
}
